import React, { useCallback, useState } from 'react';
import { Redirect, Route, Switch, useHistory, useRouteMatch } from 'react-router-dom';
import MissionList from './list/MissionList';
import MissionCreation from './creation/MissionCreation';
import { Breadcrumbs } from '../../common/components/navigation';
import MissionEdition from './edition/MissionEdition';
import MissionReupload from './edition/MissionReupload';
import Can from '../../common/contexts/abilityContext';

const MissionPage = () => {
  const [missionConfiguration, setMissionConfiguration] = useState({});

  const history = useHistory();
  const { path, url } = useRouteMatch();

  const returnToList = useCallback(() => {
    history.push(url);
  }, [history, url]);

  const handleRowClick = useCallback(
    ({ id }) => {
      history.push(`${url}/${id}`);
    },
    [history, url]
  );

  const handleOnReupload = useCallback(
    (missionCallback, id) => {
      setMissionConfiguration(missionCallback);
      history.push(`${url}/${id}/reupload`);
    },
    [history, url]
  );

  const redirectToEdition = useCallback((id) => history.push(`${url}/${id}`), [history, url]);

  const handleCreateClick = useCallback(() => history.push(`${url}/new`), [history, url]);

  const handleBackClick = useCallback(() => returnToList(), [returnToList]);

  return (
    <>
      <Breadcrumbs entityType="mission" />

      <Switch>
        <Route strict path={`${path}/new`}>
          <Can not I="create" a="mission">
            <Redirect to="/404" />
          </Can>
          <MissionCreation onBackClick={handleBackClick} onCreatedSuccess={redirectToEdition} />
        </Route>

        <Route strict path={`${path}/:id/reupload`}>
          <MissionReupload onBackClick={handleBackClick} mission={missionConfiguration} onUpdatedSuccess={redirectToEdition} />
        </Route>

        <Route strict path={`${path}/:id`}>
          <MissionEdition onBackClick={handleBackClick} onReuploadSuccess={handleOnReupload} />
        </Route>

        <Route strict path={`${path}`}>
          <MissionList onRowClick={handleRowClick} onCreateClick={handleCreateClick} />
        </Route>
      </Switch>
    </>
  );
};

export default React.memo(MissionPage);
